// eslint-disable-next-line no-use-before-define
import { Badge } from '@mui/material';
import { TermsDialog } from '@treedis/tour-loader';
import { default as classnames, default as cn } from 'classnames';
import _isEqual from 'lodash/isEqual';
import { Component, memo } from 'react';
import { TourMode } from '@/_models/Tour';
import { TourObject } from '@/_models/virtualStaging/VSObject';
import PublicAPI from '@/api/TreedisPublicDAO';
import { getDuplicates, getFloorPlans } from '@/api/queries';
import Sketchfab from '@/units/Icon/Sketchfab';
import { VideoBox } from '@/units/index';
import { AudioModule } from '../../../../components-new/common/AudioModule';
import * as all from '../../../util/all';
import { downloadFloorPlan, getVersion } from '../../../util/all';
import DeviceManager from '../../../util/deviceManager';
import { Threads } from '../../Threads/Threads';
import { AvatarChat } from '../avatar/chat/AvatarChat';
import CustomReel from './CustomReel';
import Reel from './Reel';
import ReelVideoBar from './ReelVideoBar';
import { TourVolume } from './TourVolume';
import styled from 'styled-components';

const MReelVideoBar = memo(ReelVideoBar);

const StyledNoteBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    height: '10px',
    width: '10px',
    borderRadius: '12px',
    right: 10,
    top: 4,
    padding: '0 4px',
    backgroundColor: '#F04438',
    color: 'white',
  },
}));

export default class BottomBar extends Component<any, any> {
  videoFrame: any;

  videoEventListener: any;

  videoInitTimeout: any;

  controls: any;

  tagNode: any;

  inputNodeComponent: any;

  attachToCursor: any;

  normal: any;

  clickListenerRef: any;

  constructor(props: any) {
    super(props);
    const { tour, audio, musicPausedByUser } = this.props;
    this.state = {
      musicPausedByUser,
      audio,
      tour,
      floorplan: false,
      dollhouse: false,
      measurements: false,
      activeCategory: null,
      floorPlans: [],
      reels: [],
      reelCategories: [],
      showActionsModal: tour.autoplayVideo || (tour.autoplayMusic && tour.music),
      showFloorsModal: false,
      duplicates: [],
      showLanguagesModal: false,
      showVolumeControls: false,
      showVideoReel: false,
      pdfList: false,
      cameraList: false,
      youtubeOn: false,
      restrictedReels: [],
      minimapVisible: tour.minimap && tour.minimapVisible && !props.room && window.innerWidth > 768,
      reel: [],
      newMessagesCount: 0,
      chatOpen: false,
      chatNotifications: 0,
      showTermsIframe: false,
      audioMute: false,
      defurnishOn: false,
    };
  }

  async componentDidMount() {
    const { tour, allowedTours, reel } = this.props;
    const measurements = await this.getSetting('measurements');
    const dollhouse = !!tour.addon_dh && (await this.getSetting('dollhouse'));

    const floorplan = await this.getSetting('floor_plan');

    let reelOpen = false;
    if (tour.addon_hl === 0 || tour.addon_hl === 1) reelOpen = true;
    if (tour.floorPlansEnabled) {
      const floorPlans = await getFloorPlans(this.props.tour.id);
      this.setState({ floorPlans });
    }

    const initialDuplicates = this.props?.initialDuplicates || (await getDuplicates(tour.parentId || tour.id));

    let reelsRes;

    if (tour.reel) {
      reelsRes = await PublicAPI.getReels(tour.id);
    }

    const duplicates = initialDuplicates.filter((d: any) => d?.language);

    const reels = reelsRes?.reels || [];
    const newrestrictedReels = [];
    reelsRes = {
      ...reelsRes,
      reels:
        tour.ticket === true
          ? reels.filter((r: any) => {
              if (r.type !== 'treedis' || r.url == null) return true;
              const reelURL = new URL(r.url);
              const splittedPath = reelURL.pathname.split('/');
              if (splittedPath[1] === 'tour') {
                if (Array.isArray(allowedTours) && [...allowedTours, tour.slug].includes(splittedPath[2])) return true;
                newrestrictedReels.push(r);
              } else return true;
              return false;
            })
          : reels,
    };

    this.setState(
      {
        duplicates,
        measurements,
        dollhouse,
        floorplan,
        reelOpen,
        restrictedReels: newrestrictedReels,
        reels: reelsRes?.reels,
        reelCategories: reelsRes?.categories,
        reel,
        // tour, //ADD IF YOU WANT TO OVERRIDE TOUR
      },
      () => {
        this.props.setReelOpen(this.state.reelOpen);
        if (tour.addon_hl === 0) {
          this.videoInitTimeout = setTimeout(() => {
            this.props.setReelOpen(false);
          }, 4000);
        }
        this.videoInit();
      },
    );
  }

  async componentDidUpdate(prevProps: any, prevState: any) {
    const { mainPlaying, otherPlaying, changeReel, tour, reel, threads, threadsLoaded } = this.props;
    if (tour.isThreadsEnabled && threadsLoaded && (!prevProps.threadsLoaded || !_isEqual(prevProps.threads, threads))) {
      this.setState({
        chatNotifications: threads?.unreadCount || 0,
        newMessagesCount: threads?.newMessagesCount || 0,
      });

      if (tour.id !== this.state.tour.id) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ tour });
      }
    }

    // Rest of your existing componentDidUpdate logic...

    if (changeReel) {
      const mpReel = await this.props.showcase.Tour.getData().catch(() => []);
      const reelsRes = await PublicAPI.getReels(tour.id);

      if (reelsRes?.reels?.length && tour.reel && !_isEqual(reelsRes?.reels, this.state.reels)) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ reels: reelsRes?.reels });
      } else if (!tour.reel && !_isEqual(mpReel, this.state.reels)) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ reels: mpReel, reel: [] });
      }

      if (tour.id !== this.state.tour.id) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ tour });
      }
    }

    if (prevState.tour.mpReel && reel.length !== prevState.reel.length) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ reel });
    }
    if (prevProps.mainPlaying !== mainPlaying || prevProps.otherPlaying !== otherPlaying) {
      if (mainPlaying || otherPlaying) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ youtubeOn: false });
        this.props.setTourMusicState(mainPlaying);
      }
    }

    const minimap = document.getElementById('minimap');
    const tourHasAReel = this.state.tour.reel || this.state.tour.mpReel;
    if (tourHasAReel && minimap && prevState.reelOpen !== this.props.reelOpen) {
      if (this.props.reelOpen) {
        minimap.classList.add('reel-open');
      } else minimap.classList.remove('reel-open');
    }
    if (
      (!this.state.showVideoReel && !prevState.reelVideos && this.props.reelVideos?.length > 1) ||
      (!this.state.showVideoReel && prevState.reelVideos && prevState.reelVideos.length !== this.props.reelVideos?.length)
    ) {
      this.props.setReelOpen(true);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ reelVideos: this.props.reelVideos, showVideoReel: true });
      if (this.videoInitTimeout) {
        clearTimeout(this.videoInitTimeout);
      }
    }
    if (this.state.showVideoReel && this.props.reelOpen && this.props.reelVideos?.length === 0) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ showVideoReel: false, reelVideos: [] });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('touchstart', this.videoEventListener);
    document.removeEventListener('click', this.videoEventListener);
    clearInterval(this.videoInitTimeout);
  }

  getSetting = async (setting: string) => {
    try {
      return await this.props.showcase.Settings.get(setting);
    } catch (err) {
      console.error(err);
    }
    return null;
  };

  changeFloor = async (index: number, _all = false) => {
    try {
      const { changeFloor } = this.props;
      await changeFloor(index, _all);
      this.setState({ showFloorsModal: false });
      setTimeout(() => {
        const { tour, currentFloor } = this.props;
        const music = tour.musics.find((item) => item.floor === currentFloor);
        this.props.setTourMusicState((tour.autoplayMusic || music?.autoplay) && !this.state.musicPausedByUser);
      }, 100);
    } catch (err) {
      console.error(err);
    }
  };

  filterReel = async (categoryId: number) => {
    let { reels } = this.state;
    reels = reels.map((r: any) => {
      r.hide = false;
      if (r.categoryId !== categoryId && this.state.activeCategory !== categoryId) {
        r.hide = true;
      }
      return r;
    });
    this.setState({
      reels,
      activeCategory: this.state.activeCategory !== categoryId ? categoryId : null,
    });
  };

  createLockScreen = () => {
    const lock = document.createElement('div');
    lock.id = 'video-lock-screen';
    lock.setAttribute('style', 'position: fixed; height: 100vh; width: 100vw; top: 0; left: 0; z-index: 1000');
    document.body.append(lock);
  };

  removeLockScreen = () => {
    if (document.getElementById('video-lock-screen')) {
      document.getElementById('video-lock-screen').remove();
    }
  };

  videoInit = () => {
    const { tour } = this.state;

    if (tour.videoUrl && tour.autoplayVideo) {
      this.createLockScreen();
      this.playVideo();
      if (DeviceManager.supportsTouch()) {
        this.videoEventListener = document.addEventListener(
          'touchstart',
          () => {
            this.playVideo();
            this.removeLockScreen();
          },
          { once: true },
        );
      } else {
        this.videoEventListener = document.addEventListener(
          'click',
          () => {
            this.playVideo();
            this.removeLockScreen();
          },
          { once: true },
        );
      }
    }
  };

  capitalizeFirstLetter = (str: string) => {
    if (!str) return null;

    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  defurnish = () => {
    this.props.onDefurnish();
    this.setState({defurnishOn: !this.state.defurnishOn});
  }

  playVideo = () => {
    this.props.onStartVideo();
    this.setState({ youtubeOn: true });
  };

  showVolumeControls = () => {
    const { showVolumeControls } = this.state;
    this.setState({
      showVolumeControls: !showVolumeControls,
    });
  };

  updatePlayOrPause = () => {
    const { mainPlaying } = this.state;
    this.setState({
      mainPlaying: !mainPlaying,
    });
  };

  handleReelOpen = () => {
    const newReelState = !this.props.reelOpen;
    this.props.setReelOpen(newReelState);
    this.setState({ showVideoReel: newReelState });
  };

  incrementNewMessagesCount = () => {
    this.setState((prevState) => ({
      newMessagesCount: prevState.newMessagesCount + 1,
    }));
  };

  resetNewMessagesCount = () => {
    this.setState({
      newMessagesCount: 0,
    });
  };

  decrementNewMessagesCount = () => {
    this.setState((prevState) => {
      const newValue = prevState.newMessagesCount - 1;
      return {
        newMessagesCount: newValue < 0 ? 0 : newValue,
      };
    });
  };

  toggleChatClick = () => {
    const chatOn = !this.state.chatOpen;
    this.setState({ chatOpen: chatOn, chatNotifications: 0 });
    this.props?.onToggleBottomBarActions?.({ chatOn });
  };

  setChatNotifications = () => {
    this.setState((prevState) => ({ ...prevState, chatNotifications: prevState.chatNotifications + 1 }));
  };

  public render() {
    const {
      showActionsModal,
      showFloorsModal,
      showLanguagesModal,
      floorPlans,
      minimapVisible,
      dollhouse,
      floorplan,
      measurements,
      tour,
      duplicates,
      reels,
      reel,
      reelCategories,
      restrictedReels,
      showVideoReel,
      audioMute,
      defurnishOn
    } = this.state;
    const {
      mainPlaying,
      reelStep,
      onHelpClick,
      onTermsClick,
      openShare,
      changeFull,
      moveToStep,
      tourPlaying,
      sharePopupOn,
      changeViewMode,
      measurementsMode,
      showPanorama,
      showMinimapClick,
      showPanoramaClick,
      loadModel,
      playTour,
      measurementsOn,
      panoramaOn,
      whitelabel,
      translation,
      vsObjects,
      toggleVS,
      openVR,
      currentFloor,
      isVSEnabled,
      showTicketRestrictedAreaPopup,
      mpFloors,
      host,
      onMuteClick,
      onFullscreenClick,
      toggleSketchfabPopup,
      onPinClick,
      activeSweepGroup,
      hideForWhile,
      tourMode,
      room,
      isAudioControlEnabled,
      threadsLoaded,
      flowIsActive,
    } = this.props;

    const hasVideos = Boolean(this.props.reelVideos?.length);
    const reelOpen =
      (showVideoReel || (this.props.reelOpen && !measurementsOn && ((reel && reel.length > 0 && tour.mpReel) || (tour && tour.reel && reels.length > 0)))) && !flowIsActive;
    const hasReelCategories = tour.reel && reelOpen && reelCategories?.length > 0;
    const isHasFloorMusic = tour.musics?.find((item) => item.floor === currentFloor);
    const audioHandler = AudioModule.getInstance();
    const showMore = floorPlans.length > 0 || tour.droneUrl || tour.videoUrl || (tour.screenshotEnabled && !panoramaOn) || tour.music || isHasFloorMusic;

    // hide the copyright button if sketchfab models are present
    const hasSFModels = vsObjects.some((item) => item instanceof TourObject && item?.details?.copyright);
    const showReelIcon = (tour.reel || (this.props.reel && this.props.reel.length > 0 && tour.mpReel)) && !flowIsActive;
    const showPlayIcon = tour.mpPlay && this.props.reel && this.props.reel.length > 0;
    const showDefurnishIcon = this.props.defurnishEnabled;
    const showFloorsIcon = mpFloors && mpFloors.length > 1 && tour.addon_f === true;
    const showVSIcon = tour.enableVS && vsObjects?.length > 0 && !flowIsActive;
    const showPanoIcon = showPanorama && tour.id !== 4450 && !flowIsActive;
    const showLangIcon = duplicates.length > 1;
    const iconsEnabled = [showReelIcon, showPlayIcon, dollhouse, floorplan, measurements, showFloorsIcon, showVSIcon, tour.minimap, showPanoIcon, showLangIcon, hasVideos];
    const smallIconsEnabled = iconsEnabled.filter(Boolean).length > 4 && DeviceManager.isMobile();
    const showChatIcon = tour.textChatEnabled && !room;
    const volumeButtonComponent = audioHandler?.tourHasAudio() ? <TourVolume mute={audioMute} setMute={(m) => this.setState({ audioMute: m })} /> : null;

    return (
      <>
        <div id="bottom-bar" className={classnames({ open: reelOpen, smallIcons: smallIconsEnabled, hide: hideForWhile })}>
          {showMore && (
            <div className={classnames('more-bar', { categoriesOn: hasReelCategories })}>
              {!showActionsModal && volumeButtonComponent}
              <div className="data-balloon" data-balloon={translation && translation.moreTooltip} data-balloon-pos="right">
                <button
                  className={showActionsModal ? 'more-btn btn active' : 'more-btn btn'}
                  onClick={() => {
                    this.setState({
                      showActionsModal: !showActionsModal,
                    });
                  }}
                >
                  <i className="fas fa-ellipsis-h" />
                </button>
              </div>

              <div className={classnames('action-icons left more', { active: showActionsModal })}>
                <div id="more-menu" className="more-menu">
                  {volumeButtonComponent}
                  {(tour.music || isHasFloorMusic) && (
                    <div className="data-balloon" data-balloon={translation && translation.musicTooltip} data-balloon-pos="right">
                      <div
                        className={classnames('action-icon music', mainPlaying && 'active', !isAudioControlEnabled && 'disabled-control')}
                        onClick={async () => {
                          await this.props.handleToggleMusic();
                          this.props.setTourMusicState(!audioHandler.isTourMusicPaused());
                          if (!this.props.tourAudioPlaying) {
                            this.setState({ musicPausedByUser: true });
                          } else {
                            this.setState({ musicPausedByUser: false });
                          }
                        }}
                      >
                        <i className={classnames('fas music-status fa-music')} />
                        <i className={this.props.tourAudioPlaying ? 'fas fa-pause' : 'fas fa-play'} />
                      </div>
                    </div>
                  )}

                  {tour.droneUrl && (
                    <div className="data-balloon" data-balloon={translation && translation.droneViewTooltip} data-balloon-pos="right">
                      <div className="action-icon drone" onClick={this.props.toggleExternalPopup.bind(this, tour.droneUrl)}>
                        <i className="fad fa-drone" />
                      </div>
                    </div>
                  )}
                  {tour.screenshotEnabled && !panoramaOn && (
                    <div className="data-balloon" data-balloon={translation && translation.screenshotTooltip} data-balloon-pos="right">
                      <div
                        className={this.state.cameraList ? 'action-icon screenshot active' : 'action-icon screenshot'}
                        onClick={() => {
                          this.setState({
                            cameraList: !this.state.cameraList,
                            pdfList: false,
                            youtubeOn: false,
                          });
                        }}
                      >
                        <i className="fas fa-camera" />
                      </div>
                    </div>
                  )}

                  {floorPlans.length === 1 && (
                    <div className="data-balloon" data-balloon={translation && translation.floorPlansTooltip} data-balloon-pos="right">
                      <a
                        id="pdf-list"
                        className="action-icon floors"
                        onClick={() => downloadFloorPlan(`${process.env.REACT_APP_AWS}/tours/${tour.id}/floorplans/${floorPlans[0].url}`, floorPlans[0])}
                        target="_blank"
                      >
                        <i className="fas fa-file-pdf" />
                      </a>
                    </div>
                  )}
                  {floorPlans.length > 1 && (
                    <div className="data-balloon" data-balloon={translation && translation.floorPlansTooltip} data-balloon-pos="right">
                      <div
                        className={this.state.pdfList ? 'action-icon floors active' : 'action-icon floors'}
                        onClick={() => {
                          this.setState({
                            pdfList: !this.state.pdfList,
                            youtubeOn: false,
                            cameraList: false,
                          });
                        }}
                      >
                        <i className="fas fa-file-pdf" />
                      </div>
                    </div>
                  )}

                  {tour.videoUrl && (
                    <div className="data-balloon" data-balloon={translation && translation.videoTooltip} data-balloon-pos="right">
                      <div
                        className={this.state.youtubeOn ? 'action-icon video active' : 'action-icon video'}
                        onClick={() => {
                          if (!this.state.youtubeOn) {
                            this.props.onStartVideo();
                          } else {
                            this.props.onStopVideo();
                          }
                          this.setState({
                            youtubeOn: !this.state.youtubeOn,
                            pdfList: false,
                            cameraList: false,
                          });
                        }}
                      >
                        <i className="fas fa-video" />
                      </div>
                    </div>
                  )}
                </div>
                {this.state.cameraList && (
                  <div className="pdf-list wide">
                    <a
                      onClick={this.props.takeScreenshot.bind(this, {
                        width: 4096,
                        height: 3072,
                      })}
                    >
                      4:3 @ 4096x3072 (High)
                    </a>
                    <a
                      onClick={this.props.takeScreenshot.bind(this, {
                        width: 1920,
                        height: 1440,
                      })}
                    >
                      4:3 @ 1920x1440 (Medium)
                    </a>
                    <a
                      onClick={this.props.takeScreenshot.bind(this, {
                        width: 1280,
                        height: 960,
                      })}
                    >
                      4:3 @ 1280x960 (Web)
                    </a>
                    <a
                      onClick={this.props.takeScreenshot.bind(this, {
                        width: 1024,
                        height: 768,
                      })}
                    >
                      4:3 @ 1024x768 (MLS)
                    </a>
                    <a
                      onClick={this.props.takeScreenshot.bind(this, {
                        width: 4096,
                        height: 2034,
                      })}
                    >
                      16:9 @ 4096x2304 (Wide/HQ)
                    </a>
                    <a
                      onClick={this.props.takeScreenshot.bind(this, {
                        width: 3840,
                        height: 2160,
                      })}
                    >
                      16:9 @ 3840x2160 (Wide/4K)
                    </a>
                    <a
                      onClick={this.props.takeScreenshot.bind(this, {
                        width: 1920,
                        height: 1080,
                      })}
                    >
                      16:9 @ 1920x1080 (Wide/1080p)
                    </a>
                    <a
                      onClick={this.props.takeScreenshot.bind(this, {
                        width: 1280,
                        height: 720,
                      })}
                    >
                      16:9 @ 1280x720 (Wide/720p)
                    </a>
                    <a
                      onClick={this.props.takeScreenshot.bind(this, {
                        width: 1024,
                        height: 576,
                      })}
                    >
                      16:9 @ 1024x576 (MLS)
                    </a>
                    {/* Too heavy <a onClick={this.props.takeScreenshot.bind(this, {width: 8192, height: 4552})}>Max @ 8192x4552 (DPI Varies)</a> */}
                    <a onClick={this.props.takePano.bind(this)}>Pano @ 4096x2048</a>
                  </div>
                )}

                {this.state.pdfList && (
                  <div className="pdf-list">
                    {floorPlans.map((plan: any, i: number) => (
                      <a
                        key={i}
                        onClick={() => {
                          downloadFloorPlan(`${process.env.REACT_APP_AWS}/tours/${tour.id}/floorplans/${plan.url}`, plan);
                        }}
                        className="pdf_inner_link"
                        target="_blank"
                      >
                        {plan.name}
                      </a>
                    ))}
                  </div>
                )}
                {tour.videoUrl && this.state.youtubeOn && (
                  <VideoBox.Container
                    width={tour.videoWidth}
                    height={tour.videoHeight}
                    isMobile={DeviceManager.isMobile() && !DeviceManager.isTablet()}
                    landscape={DeviceManager.isHorizontalMobileView()}
                  >
                    <VideoBox.Icon
                      className="fas fa-times"
                      onClick={() => {
                        this.props.onStopVideo();
                        this.setState({ youtubeOn: false });
                      }}
                    />
                    <VideoBox.Iframe
                      ref={(elem: any) => {
                        this.videoFrame = elem;
                      }}
                      id="ytplayer"
                      allowFullScreen
                      allow="autoplay; fullscreen"
                      src={all.getVideoLink(tour.videoUrl, {
                        mute: tour.noAudioMode || tour.autoplayVideo,
                      })}
                      frameBorder="0"
                    />
                  </VideoBox.Container>
                )}
              </div>
            </div>
          )}
          <div className={classnames('action-icons right', { categoriesOn: tour.reel && reelOpen && reelCategories?.length > 0 })}>
            {tour.share && (
              <div className="data-balloon" data-balloon={translation && translation.shareTooltip} data-balloon-pos="up">
                <div className={`action-icon ${sharePopupOn ? 'active' : ''}`} role="button" tabIndex={0} onKeyPress={() => null} onClick={openShare}>
                  <i className="fas fa-share-alt" />
                </div>
              </div>
            )}

            {!DeviceManager.isMobile() && (
              <div className="data-balloon" data-balloon={translation && translation.fullScreenTooltip} data-balloon-pos="up">
                <div className="action-icon" onClick={() => changeFull()}>
                  <i className={this.props.isFull ? 'fas fa-compress' : 'fas fa-expand'} />
                </div>
              </div>
            )}

            {!!tour.addon_vr && !navigator.userAgent.includes('Android') && (
              <div className="data-balloon" data-balloon={translation && translation.vrTooltip} data-balloon-pos="up">
                <div className="action-icon" role="button" tabIndex={0} onClick={openVR}>
                  <i className="fas fa-vr-cardboard" />
                </div>
              </div>
            )}
          </div>
          <div id="bottom-bar-help">
            <button
              className={classnames('btn', 'btn-auto-width')}
              onClick={() => {
                if ((translation && translation.termFile) || tour.termsUrl) {
                  this.setState({ showTermsIframe: !this.state.showTermsIframe });
                } else {
                  onTermsClick();
                }
              }}
            >
              {translation && translation.terms}
            </button>
            <button className="btn" onClick={onHelpClick}>
              {translation && translation.help}
            </button>
            <a href={whitelabel?.website} rel="noreferrer" target="_blank">
              <img src={whitelabel?.logo} alt="" />
            </a>
            <a href="https://matterport.com" rel="noreferrer" target="_blank">
              <img className="mp-logo" src="/images/matterport.svg" alt="matterport" />
            </a>
            {hasSFModels && (
              <button className="btn" onClick={toggleSketchfabPopup(true)}>
                <Sketchfab style={{ width: '16px', height: '16px' }} />
              </button>
            )}
          </div>
          <div className={classnames('actions-bar')} style={{ overflow: 'visible' }}>
            {!showMore && volumeButtonComponent}
            {activeSweepGroup && activeSweepGroup.displayTitle && <h2 className="active-sg-title mb-2 ml-5">{activeSweepGroup.title}</h2>}
            <div style={{ overflow: 'visible' }} className={classnames('main-icons', { categoriesOn: tour.reel && reelOpen && reelCategories?.length > 0 })}>
              {showReelIcon && (
                <div className="data-balloon" data-balloon={translation && translation.highlightsTooltip} data-balloon-pos="up">
                  <button className={reelOpen ? 'actions-btn btn active reel' : 'actions-btn btn reel'} onClick={this.handleReelOpen}>
                    <i className="fas fa-angle-up" />
                  </button>
                </div>
              )}

              {showPlayIcon && (
                <div className="data-balloon" data-balloon={translation && translation.playTourTooltip} data-balloon-pos="up">
                  <button
                    className={tourPlaying ? 'btn active' : 'btn'}
                    onClick={() => {
                      playTour();
                    }}
                  >
                    <i className={tourPlaying ? 'fas fa-pause-circle' : 'fas fa-play-circle'} />
                  </button>
                </div>
              )}
              {(dollhouse || floorplan) && (tourMode === TourMode.DOLLHOUSE || tourMode === TourMode.FLOORPLAN) && (
                <div className="data-balloon" data-balloon={translation && translation.backInsideTooltip} data-balloon-pos="up">
                  <button className="btn" onClick={() => changeViewMode(TourMode.INSIDE)}>
                    <i className="fas fa-walking" />
                  </button>
                </div>
              )}
              {dollhouse && !tour.navigationWebEnabled && (
                <div className="data-balloon" data-balloon={translation && translation.dollhouseTooltip} data-balloon-pos="up">
                  <button className="btn" onClick={() => changeViewMode(TourMode.DOLLHOUSE)}>
                    <i className="mp-dollhouse" />
                  </button>
                </div>
              )}
              {floorplan && (
                <div className="data-balloon" data-balloon={translation && translation.floorPlanTooltip} data-balloon-pos="up">
                  <button className="btn" onClick={() => changeViewMode(TourMode.FLOORPLAN)}>
                    <i className="mp-floorplan" />
                  </button>
                </div>
              )}
              {measurements && (
                <div className="data-balloon" data-balloon={translation && translation.measurementsTooltip} data-balloon-pos="up">
                  <button
                    className="btn"
                    onClick={() => {
                      if (panoramaOn) showPanoramaClick();
                      measurementsMode();
                    }}
                  >
                    <i className="fas fa-ruler" />
                  </button>
                </div>
              )}

              {showDefurnishIcon && <div className="data-balloon" data-balloon={translation && translation.defurnishTooltip} data-balloon-pos="up">
                  <button
                    className={defurnishOn ? 'btn active' : 'btn'}
                    onClick={() => {
                      this.defurnish();
                    }}
                  >
                    <i className="fas fa-couch" />
                  </button>
                </div>}

              {showFloorsIcon && (
                <div className="data-balloon" style={{ overflow: 'visible' }} data-balloon={translation && translation.floorsTooltip} data-balloon-pos="up">
                  <button
                    className="btn"
                    onClick={() => {
                      this.setState({
                        showFloorsModal: !showFloorsModal,
                      });
                    }}
                  >
                    <i className="fas fa-layer-group" />
                  </button>
                  {showFloorsModal && (
                    <div className="floors-modal">
                      <ul>
                        <li onClick={() => this.changeFloor(0, true)}>{translation?.floorAll || 'All'}</li>
                        {mpFloors.map((floor: any) => (
                          <li
                            key={`${floor.id}-${floor.name}`}
                            className={this.props.currentFloor === floor.sequence ?? floor.id ? 'active' : ''}
                            onClick={() => this.changeFloor(floor.sequence ?? floor.id)}
                          >
                            {floor.name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {showVSIcon && (
                <div className="data-balloon" data-balloon={translation && translation.hideVSTooltip} data-balloon-pos="up">
                  <button className={classnames('btn', isVSEnabled && 'active')} onClick={toggleVS}>
                    <i className="fas fa-cube" />
                  </button>
                </div>
              )}

              {tour.minimap && (
                <div className="data-balloon" data-balloon={translation && translation.minimapTooltip} data-balloon-pos="up">
                  <button
                    className={minimapVisible ? 'btn active' : 'btn'}
                    onClick={() => {
                      this.setState({ minimapVisible: !minimapVisible });
                      showMinimapClick();
                    }}
                  >
                    <i className="fas fa-map-marked" />
                  </button>
                </div>
              )}

              {showPanoIcon && (
                <div className="data-balloon" data-balloon={translation && translation.panoramaTooltip} data-balloon-pos="up">
                  <button className={panoramaOn ? 'btn active' : 'btn'} onClick={showPanoramaClick}>
                    <img className="panorama-icon" src="/images/panorama.png" alt="panorama" />
                  </button>
                </div>
              )}

              {showLangIcon && (
                <div className="data-balloon" data-balloon={translation && translation.languagesTooltip} data-balloon-pos="up">
                  <button
                    className="btn"
                    onClick={() => {
                      this.setState({
                        showLanguagesModal: !showLanguagesModal,
                      });
                    }}
                  >
                    <i className="fas fa-language" />
                  </button>
                  {showLanguagesModal && (
                    <div className="languages-modal">
                      <ul>
                        {duplicates.map((duplicate: any) => (
                          <li key={duplicate.slug} className={tour.id === duplicate.id ? 'active' : ''} onClick={() => this.setState({ showLanguagesModal: false })}>
                            <a href={`/tour/${duplicate.slug}`}>{this.capitalizeFirstLetter(duplicate?.language)}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {hasVideos && (
                <div className="data-balloon" data-balloon={translation && translation.participantsTooltip} data-balloon-pos="up">
                  <button
                    className={cn('btn participant', showVideoReel && 'active')}
                    style={showVideoReel ? { backgroundColor: 'var(--color-secondary)' } : undefined}
                    onClick={() => {
                      if (!showVideoReel) {
                        this.props.setReelOpen(true);
                        this.setState({
                          showVideoReel: true,
                        });
                      } else {
                        this.props.setReelOpen(false);
                        this.setState({
                          showVideoReel: false,
                        });
                      }
                    }}
                  >
                    <i className="fas fa-users" />
                  </button>
                </div>
              )}

              {tour.isThreadsEnabled && !room && !flowIsActive && (
                <StyledNoteBadge badgeContent={this.state.newMessagesCount} variant="dot">
                  <div className="data-balloon" data-balloon="Notes" data-balloon-pos="up">
                    <button
                      className="btn"
                      onClick={() => {
                        this.props.toggleThreadsDrawer();
                        this.setState({ newMessagesCount: 0 });
                      }}
                      disabled={!threadsLoaded}
                    >
                      <i className="fa-solid fa-comment" />
                    </button>
                  </div>
                </StyledNoteBadge>
              )}

              {showChatIcon && (
                <Badge badgeContent={this.state.chatOpen ? 0 : this.state.chatNotifications} color="primary">
                  <div className="data-balloon" data-balloon={translation.chatTooltip || 'Chat'} data-balloon-pos="up">
                    <button className="btn" onClick={this.toggleChatClick}>
                      <i className="fas fa-comments" />
                    </button>
                  </div>
                </Badge>
              )}
            </div>
            {tour.reel && reelOpen && !showVideoReel && reelCategories?.length > 0 && (
              <div id="reel-categories">
                <div className="scroll-div d-flex">
                  {reelCategories.map((c: any, i: number) => (
                    <span className={this.state.activeCategory === c.id ? 'active' : ''} key={i} onClick={this.filterReel.bind(this, c.id)}>
                      {c.title}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          {tour.mpReel && reel && reel.length > 0 && !tour.reel && !showVideoReel && <Reel reel={reel} reelStep={reelStep} move={moveToStep} />}

          {tour.reel && !showVideoReel && !!reels.length && (
            <CustomReel
              reel={reels}
              tourId={tour.id}
              loadModel={loadModel}
              restrictedReels={restrictedReels}
              showTicketRestrictedAreaPopup={showTicketRestrictedAreaPopup}
              onTicketingReel={this.props.onTicketingReel}
            />
          )}

          <MReelVideoBar
            show={showVideoReel && hasVideos}
            host={host}
            videos={this.props.reelVideos}
            onMuteClick={onMuteClick}
            onFullscreenClick={onFullscreenClick}
            onPinClick={onPinClick}
            audioOnly={this.props.audioOnly}
          />
          {tour.isThreadsEnabled && !room && threadsLoaded && !flowIsActive && (
            <Threads
              isOpen={this.props.isThreadsDrawerOpen}
              selectedThreadProp={this.props.selectedThread}
              closeDrawer={() => {
                this.props.closeThreadsDrawer();
              }}
              openDrawer={() => {
                this.props.openThreadsDrawer();
              }}
              showCaseTemp={this.props.showCaseTemp}
              showcaseTag={this.props.showcaseTag}
              tour={tour}
              iframe={this.props.iframe}
              initialThreads={this.props.threads}
              appState={this.props.appState}
              addThreadToSpace={this.props.addThreadToSpace}
              showcase={this.props.showcase}
              incrementNewMessagesCount={this.incrementNewMessagesCount}
              decrementNewMessagesCount={this.decrementNewMessagesCount}
              resetNewMessagesCount={this.resetNewMessagesCount}
              removeThreadFromSpace={this.props.removeThreadFromSpace}
              toggleThreadVisibility={this.props.toggleThreadVisibility}
              hideElements={this.props.hideElements}
              moveToTag={this.props.moveToTagIO}
              getLocation={this.props.getShareLocation}
              isRtl={tour.client?.rtl}
            />
          )}
          {this.state.chatOpen && (
            <AvatarChat chatOpen={this.state.chatOpen} toggleChatClick={this.toggleChatClick} setNotifications={this.setChatNotifications} avatar={this.props.avatar} />
          )}
        </div>
        {this.state.showTermsIframe && (
          <TermsDialog
            open={this.state.showTermsIframe}
            onClose={() => this.setState({ showTermsIframe: false })}
            logo={whitelabel?.logo}
            url={tour.termsUrl || `${process.env.REACT_APP_AWS}/tours/${tour.id}/termFile.pdf${getVersion(new Date())}`}
          />
        )}
      </>
    );
  }
}
